import React from 'react';
import {Card, ListGroup} from 'react-bootstrap';
import '../../ChantierInfoToDoList/ToDoList.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck, faXmark, faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import {useNavigate} from 'react-router';
import {useParams} from 'react-router-dom';

/**
 *  L'accueil
 * @param {*} props props
 * @return {JSX}
 */
function TodoList(props) {

  const navigate = useNavigate();
  const {id} = useParams();
  const todolist = props.todolist
  const returnTo = 'historique' 

  return (
    <div className="checkin-container">
      <Card className="checkin-card">
        <Card.Header className="checkin-header">
          <span style={{fontWeight: 'bold', textDecoration: 'underline'}}>TODOLIST</span> {props.formatDate(props.todolist.date)}
          <button className="checkin-pagination-button float-end" onClick={() => navigate('/UpdateTodolist', {state: {todolist, id, returnTo}})}><FontAwesomeIcon icon={faPencilAlt} /></button>
        </Card.Header>

        <ListGroup variant="flush">
          <ListGroup.Item className="checkin-list-item">
            Employé: {props.todolist.user_name}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item">
            Description: {props.todolist.description}
          </ListGroup.Item>
          <ListGroup.Item
            className="checkin-list-item"
            style={{
              backgroundColor:
              props.todolist.complete === 1 ? 'green' : 'red',
            }}>
            Complété: {props.todolist.complete === 1 ? <FontAwesomeIcon icon={faCheck} style={{fontSize: '25px'}} /> : <FontAwesomeIcon icon={faXmark} style={{fontSize: '25px'}} />}
          </ListGroup.Item>
          <ListGroup.Item className="checkin-list-item">
            Date complété: {props.todolist.date_complete}
          </ListGroup.Item>


          <ListGroup.Item className="checkin-list-item">
            Employé complété: {props.todolist.user_name_complete}
          </ListGroup.Item>
        </ListGroup>
      </Card>
    </div>
  );
}

export default TodoList;
